

<div class="container my-5">
    
<form   (ngSubmit)="getUserData (rForm)" [formGroup]="rForm" class="w-75 mx-auto my-5">


    <div class="form-group">
        <label>First Name</label>
        <input [class.is-valid]="rForm.get('first_name').status == 'VALID' " formControlName="first_name" type="text" class="form-control">
        <p  *ngIf="rForm.get('first_name').errors != null && rForm.get('first_name').touched " class="alert alert-danger">please enter valid first name</p>
    </div>
    
    <div class="form-group">
        <label>Last Name</label>
        <input [class.is-valid]="rForm.get('last_name').status == 'VALID' "  formControlName="last_name" type="text" class="form-control">
        <p *ngIf="rForm.get('last_name').errors != null && rForm.get('last_name').touched" class="alert alert-danger">please enter valid last name</p>
    </div>
    
    <div class="form-group">
        <label>age</label>
        <input  [class.is-valid]="rForm.get('age').status == 'VALID' " formControlName="age" type="text" class="form-control">
        <p *ngIf="rForm.get('age').errors != null && rForm.get('age').touched" class="alert alert-danger">please enter valid  age</p>
    </div>
    
    <div class="form-group">
        <label>Email</label>
        <input [class.is-valid]="rForm.get('email').status == 'VALID' " formControlName="email" type="email" class="form-control">
        <p  *ngIf="rForm.get('email').errors != null && rForm.get('email').touched" class="alert alert-danger">please enter valid Email</p>
    </div>

    <div class="form-group">
        <label>password</label>
        <input [class.is-valid]="rForm.get('password').status == 'VALID' " formControlName="password" type="password" class="form-control">
        <!-- 
            <p *ngIf="rForm.get('password').value == '' " class="alert alert-info">At least 8 characters in length  <br> Lowercase letters <br>  Uppercase letters <br> Numbers Special characters</p> 
        -->
        <p *ngIf="rForm.get('password').errors != null && rForm. get('password').touched" class="alert alert-danger">please enter valid  age</p>
    </div>
    
   
    

    <p > {{messageError}}   </p>
    
    <button [disabled]="rForm.untouched || (rForm.touched&& rForm.status == 'INVALID')"  type="submit" class="btn btn-primary">Register</button>
</form>
</div>